import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DocumentIndexComponent, MasterIndexComponent, DocumentAssociationIndexComponent, PresetAssociationIndexComponent } from './index';
import { CanActivateGuard } from './../shared/index';

export const AssociationRoutes: Routes = [
    {
        path: 'association/documentdetails',
        component: DocumentIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'association/equipment',
        component: MasterIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'association/document',
        component: DocumentAssociationIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'association/preset',
        component: PresetAssociationIndexComponent,
        canActivate: [CanActivateGuard]
    }
];

export const AssociationRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(AssociationRoutes);
